import translations from './messages.json';
export { translations };
export type Copy = typeof translations.es;
export type Language = 'es' | 'en';
export function statusLabel(copy: Copy, status: string): string {
  return status in copy ? copy[status as keyof Copy] : status;
}
export function dateLabel(value: string, language: Language): string {
  return new Intl.DateTimeFormat(language === 'es' ? 'es-PE' : 'en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'America/Lima',
  }).format(new Date(value));
}
export function numberLabel(value: string, language: Language): string {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return value;
  return new Intl.NumberFormat(language === 'es' ? 'es-PE' : 'en-US').format(
    parsed
  );
}
